export default ['disponibili', 'opzionati', 'altriOpzionati', 'venduti'];
